import { Link } from 'react-router-dom';
import Icon from '../components/Icons';
import Contato from '../components/Contato';
import { site, praca, linkWhatsApp } from '../config';
import { SLUG_BRASILIA } from '../seo';
import './ServicoPagina.css';
import './ContatoPagina.css';

const urgente =
  'Olá, preciso de atendimento urgente. Há uma pessoa presa e gostaria de falar com o advogado imediatamente.';

export default function ContatoPagina() {
  return (
    <article className="contato-pagina">
      <header className="servico-topo servico-topo--curto">
        <div className="container">
          <nav className="trilha" aria-label="Você está em">
            <ol>
              <li>
                <Link to="/">Início</Link>
              </li>
              <li>
                <span aria-current="page">Contato</span>
              </li>
            </ol>
          </nav>

          <span className="rotulo">Contato</span>
          <h1 className="servico-topo__titulo">Fale com o advogado</h1>
          <p className="servico-topo__texto">
            Atendimento em todo o Brasil por videoconferência e presencial no
            Distrito Federal, com hora marcada. Em caso de prisão em flagrante,
            ligue antes de qualquer depoimento — nesse cenário, o tempo é a
            variável mais importante.
          </p>

          <ul className="contato-pagina__canais">
            <li>
              <a href={linkWhatsApp(urgente)} target="_blank" rel="noopener noreferrer">
                <Icon name="whatsapp" size={22} />
                <span>
                  <strong>WhatsApp — urgência</strong>
                  <span>{site.celular}</span>
                </span>
              </a>
            </li>
            <li>
              <a href={`tel:${site.telefoneLink}`}>
                <Icon name="telefone" size={22} />
                <span>
                  <strong>Telefone</strong>
                  <span>{site.telefone}</span>
                </span>
              </a>
            </li>
            <li>
              <a href={`mailto:${site.email}`}>
                <Icon name="email" size={22} />
                <span>
                  <strong>E-mail</strong>
                  <span>{site.email}</span>
                </span>
              </a>
            </li>
            <li>
              <div>
                <Icon name="local" size={22} />
                <span>
                  <strong>Base</strong>
                  <span>{praca} · atendimento em todo o Brasil</span>
                </span>
              </div>
            </li>
          </ul>
        </div>
      </header>

      <Contato cabecalho={false} />

      <section className="secao">
        <div className="container contato-pagina__aviso">
          <h2>Antes de escrever</h2>
          <ul className="lista-marcada">
            <li>
              <Icon name="check" size={17} />
              <span>
                Tenha em mãos, se possível: nome completo de quem está
                envolvido, número do boletim de ocorrência ou do processo,
                delegacia ou vara, e datas relevantes.
              </span>
            </li>
            <li>
              <Icon name="check" size={17} />
              <span>
                Evite enviar documentos sigilosos no primeiro contato. Eles são
                solicitados depois, por canal combinado.
              </span>
            </li>
            <li>
              <Icon name="check" size={17} />
              <span>
                O contato inicial é protegido pelo sigilo profissional e não
                gera, por si só, relação entre advogado e cliente.
              </span>
            </li>
          </ul>

          <p className="contato-pagina__local">
            Procurando atendimento presencial no Distrito Federal?{' '}
            <Link to={`/${SLUG_BRASILIA}`}>
              Veja como funciona a atuação no DF
            </Link>
            .
          </p>
        </div>
      </section>
    </article>
  );
}
